import { offlineDatabase } from '../database/offlineDatabase/offlineDatabase';
import { PageParams } from '../repositories/common/types/createOfflineCommonRepository.types';
import { offlinePriceTablesRepository } from '../repositories/offlinePriceTables.repository';
import { OfflinePriceTableTransformers } from '../transformers/OfflineDatabasePriceTable.transformers';
import { OfflinePaginatedParamsWithQuery } from './types/common.types';
import { notImplementedInOfflineError } from './utils/repository.offlineAdapters.utils';

const page = async ({ limit, skip, query }: OfflinePaginatedParamsWithQuery) => {
  const params: PageParams = query ? { limit, skip, query } : { limit, skip };
  const pageOfflinePriceTable = await offlinePriceTablesRepository.page(params);
  const customers = pageOfflinePriceTable.data.map(
    OfflinePriceTableTransformers.toOnlinePriceTable,
  );
  return {
    data: customers,
    count: pageOfflinePriceTable.count,
  };
};

const toggleActive = () => notImplementedInOfflineError('toggleActive');

const setAsDefault = async (id: string) => {
  const currentDefault = await offlinePriceTablesRepository.getDefault();
  if (currentDefault) {
    await offlineDatabase.priceTables.update(currentDefault.id, { defaultTable: false });
  }
  await offlineDatabase.priceTables.update(id, { defaultTable: true });
  return { ok: true, data: null };
};

export const priceTablesRepositoryOfflineAdapters = {
  page,
  toggleActive,
  setAsDefault,
};
